function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavOffersAdd = function SvgNavOffersAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24.2 14.9c-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5 8.5-3.8 8.5-8.5-3.8-8.5-8.5-8.5zm4.9 9.2c0 .4-.3.7-.7.7h-2.9v2.9c0 .4-.3.7-.7.7h-1.3c-.4 0-.7-.3-.7-.7v-2.9H20c-.4 0-.7-.3-.7-.7v-1.3c0-.4.3-.7.7-.7h2.9v-2.9c0-.4.3-.7.7-.7h1.3c.4 0 .7.3.7.7v2.9h2.9c.4 0 .7.3.7.7v1.3h-.1z",
    style: {
      fill: "#00cc67"
    }
  }));
};
export default SvgNavOffersAdd;